export const systemPtBR = {
  // LegalPage
  'system.legal.fallbackTitle': 'Documento',
  'system.legal.fallbackBody': 'Não encontrado.',
  'system.legal.lastUpdated': 'Última atualização em {date}',

  // NotFoundPage
  'system.notFound.seoTitle': 'Perdido no Véu',
  'system.notFound.heading': 'Você se desviou para além das bordas do mapa',
  'system.notFound.body': 'O caminho que procurava foi engolido pelo crepúsculo eterno.',
  'system.notFound.returnCta': 'Voltar ao Véu',

  // RouteErrorBoundary
  'system.error.unknownDisturbance': 'Uma perturbação desconhecida abriu uma fissura no véu.',
  'system.error.seoTitle': 'Uma Perturbação no Véu',
  'system.error.heading': 'O ritual se desmoronou',
  'system.error.body':
    'Algo invisível interrompeu esta página. O véu está fino por aqui — tente novamente ou volte para um lugar seguro.',
  'system.error.tryAgain': 'Tentar Novamente',
  'system.error.returnCta': 'Voltar ao Véu',
  'licenseGate.heading': "Em breve — restrito por licença",
  'licenseGate.body': "Esta edição no seu idioma ainda não está disponível por questões de licenciamento. Está a caminho — volte em breve.",
} as const
